"use client";

import React, { useState } from "react";
import Icon from "@/components/ui/Icon";

interface BlogShareBarProps {
  title: string;
  slug: string;
}

export default function BlogShareBar({ title, slug }: BlogShareBarProps) {
  const [copied, setCopied] = useState(false);
  const articleUrl = `https://beyondambitionlimited.com/blog/${slug}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(articleUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      // Fallback
    }
  };

  const shareTwitter = () => {
    const text = encodeURIComponent(`Reading "${title}" on @beyondambition engineering blog:`);
    const url = encodeURIComponent(articleUrl);
    window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, "_blank");
  };

  const shareLinkedIn = () => {
    const url = encodeURIComponent(articleUrl);
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, "_blank");
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 py-4 my-8 border-y border-outline-variant/30 text-xs sm:text-sm">
      <div className="flex items-center gap-2 text-secondary font-semibold">
        <Icon name="globe" size={16} className="text-primary" />
        <span>Share Technical Insights:</span>
      </div>

      <div className="flex items-center gap-2.5">
        <button
          onClick={shareTwitter}
          type="button"
          aria-label="Share on X (formerly Twitter)"
          className="px-3 py-1.5 rounded-lg bg-surface-container/80 hover:bg-surface-container text-on-surface font-semibold border border-outline-variant/40 hover:border-primary/50 transition-all flex items-center gap-1.5 cursor-pointer text-xs"
        >
          <span>Share on X</span>
        </button>

        <button
          onClick={shareLinkedIn}
          type="button"
          aria-label="Share on LinkedIn"
          className="px-3 py-1.5 rounded-lg bg-surface-container/80 hover:bg-surface-container text-on-surface font-semibold border border-outline-variant/40 hover:border-primary/50 transition-all flex items-center gap-1.5 cursor-pointer text-xs"
        >
          <span>LinkedIn</span>
        </button>

        <button
          onClick={handleCopy}
          type="button"
          aria-label="Copy article link to clipboard"
          className="px-3 py-1.5 rounded-lg bg-primary/10 hover:bg-primary/20 text-primary font-bold border border-primary/30 transition-all flex items-center gap-1.5 cursor-pointer text-xs"
        >
          {copied ? (
            <>
              <Icon name="check" size={14} className="text-emerald-500" />
              <span className="text-emerald-600 dark:text-emerald-400">Link Copied!</span>
            </>
          ) : (
            <>
              <Icon name="file_text" size={14} />
              <span>Copy Link</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
}
